export const hasAudioAds = (state) => state.audioAdsSettings.hasAudioAds;
export const applyToRelays = (state) => state.audioAdsSettings.applyToRelays;
